import { React, useContext, useState, useEffect } from 'react';
import { AuthContext } from '../../../../contexts/authContext';
import { useNavigate } from 'react-router-dom';

import { IconChevronRight, IconChevronLeft } from '@tabler/icons-react';
import AppHdWithReturnLeft from '../../../../composents/Headers/AppHeaders/AppHdWithReturnLeft/AppHdWithReturnLeft';
import AppDesktopLogo from '../../../../composents/Logo/AppDesktopLogo/AppDesktopLogo';
import MentionsLegalesModal from '../../../Constants/MentionsLegalesModal';

const Disclaimer = () => {
    const { getToken } = useContext(AuthContext);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [mentionsLegalesOpened, setMentionsLegalesOpened] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const token = getToken();
        if (!token) {
            navigate("/app/login");
            return;
        };

        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
          };
          window.addEventListener('resize', handleResize);
          return () => {
            window.removeEventListener('resize', handleResize);
          };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    return(
        <>
            {isMobile ? (
                <>
                <AppHdWithReturnLeft>Mentions légales</AppHdWithReturnLeft>
                <div className='width90pCenter'>
                    <p id="syndicOpenedMLGa4" className="mrgL10 txt15 bT" style={{ cursor: 'pointer' }} onClick={() => setMentionsLegalesOpened(true)}>Mentions légales</p>
                    <hr style={{ border: 'none', borderTop: '1px solid #ddd', margin: '1rem 0' }} />

                    <div className="mrgB10"></div>

                    <a href="https://res.cloudinary.com/do9t6jjdy/image/upload/v1693765220/LPG002_Conditions_G%C3%A9n%C3%A9rales_d_Utilisation_v.2_0923_idmckv.pdf" target="_blank" rel="noreferrer" className="aReset bT">
                        <p id="syndicOpenedCGUGa4" className="mrgL10 txt15">Conditions Générales d'Utilisation</p>
                    </a>
                    <hr style={{ border: 'none', borderTop: '1px solid #ddd', margin: '1rem 0' }} />

                    <div className="mrgB10"></div>
                    
                    <a href="https://res.cloudinary.com/do9t6jjdy/image/upload/v1702889743/RGPD-P-001_-_Politique_de_confidentialit%C3%A9_v.3_1223_gcrwbv.pdf" target="_blank" rel="noreferrer"className="aReset bT">   
                        <p id="syndicOpenedRGPDGa4" className="mrgL10 txt15">Protection des données</p>
                    </a>
                    <hr style={{ border: 'none', borderTop: '1px solid #ddd', margin: '1rem 0' }} />
                </div>
                </>
            ) : (
                <>
                    <AppDesktopLogo/>
                    <div className="offer-desktop-page-bg" style={{ padding: "0 0 60px", alignItems: "flex-start", flexDirection: "column" }}>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr auto 1fr", alignItems: "center", margin: "40px auto 20px", width: "39%" }}>
                        <button
                            type="button"
                            onClick={() => navigate(-1)}
                            style={{
                                height: 36,
                                width: 110,
                                opacity: 0.9,
                                backgroundColor: "#FFFFFF",
                                borderRadius: 50,
                                border: "none",
                                padding: "0 12px",
                                boxShadow: "0 1px 6px rgba(0,0,0,0.18)",
                                cursor: "pointer",
                                justifySelf: "start",
                            }}
                        >
                            <div className="horizontal iCenter">
                                <IconChevronLeft width={20} />
                                <p className="txt18 medium noMrgTB mrgL5">Retour</p>
                            </div>
                        </button>
                        <h2 className="noMrgTB" style={{ gridColumn: 2, justifySelf: "center" }}>Mentions légales</h2>
                        <div />
                    </div>

                    <div className="offer-form-card" style={{ width: "39%" }}>
                        <div>
                            <div className="horizontal iCenter spaceBtw bT" style={{ cursor: 'pointer' }} onClick={() => setMentionsLegalesOpened(true)}>
                                <p id="prestaOpenedMLGa4" className="mrgL10 txt18 mrgT10 mrgB10">Mentions légales</p>
                                <IconChevronRight width={19} className='mrgR20'/>
                            </div>
                            <hr style={{ border: 'none', borderTop: '1px solid #ddd', margin: '1rem 0' }} />

                            <div className="mrgB10"></div>

                            <a href="https://res.cloudinary.com/do9t6jjdy/image/upload/v1693765220/LPG002_Conditions_G%C3%A9n%C3%A9rales_d_Utilisation_v.2_0923_idmckv.pdf" target="_blank" rel="noreferrer" className="aReset bT">
                                <div className="horizontal iCenter spaceBtw">
                                    <p id="prestaOpenedCGUGa4" className="mrgL10 txt18 mrgT10 mrgB10">Conditions Générales d'Utilisation</p>
                                    <IconChevronRight width={19} className='mrgR20'/>
                                </div>
                            </a>
                            <hr style={{ border: 'none', borderTop: '1px solid #ddd', margin: '1rem 0' }} />
                            <div className="mrgB10"></div>

                            <a href="https://res.cloudinary.com/do9t6jjdy/image/upload/v1702889743/RGPD-P-001_-_Politique_de_confidentialit%C3%A9_v.3_1223_gcrwbv.pdf" target="_blank" rel="noreferrer"className="aReset bT">
                                <div className="horizontal iCenter spaceBtw">
                                    <p id="prestaOpenedRGPDGa4" className="mrgL10 txt18 mrgT10 mrgB10">Protection des données</p>
                                    <IconChevronRight width={19} className='mrgR20'/>
                                </div>
                            </a>
                        </div>
                    </div>
                    </div>
                </>
            )}
            <MentionsLegalesModal opened={mentionsLegalesOpened} onClose={() => setMentionsLegalesOpened(false)} />
        </>
    )
}

export default Disclaimer;

